export const GET_SERVICE_NUMBER_LIST_REQUEST = 'GET_SERVICE_NUMBER_LIST_REQUEST';
export const GET_SERVICE_NUMBER_LIST_SUCCESS = 'GET_SERVICE_NUMBER_LIST_SUCCESS';
export const GET_SERVICE_NUMBER_LIST_FAILURE = 'GET_SERVICE_NUMBER_LIST_FAILURE';

export const GET_SERVICE_ELIGIBILITY_DETAILS_REQUEST = 'GET_SERVICE_ELIGIBILITY_DETAILS_REQUEST';
export const GET_SERVICE_ELIGIBILITY_DETAILS_SUCCESS = 'GET_SERVICE_ELIGIBILITY_DETAILS_SUCCESS';
export const GET_SERVICE_ELIGIBILITY_DETAILS_FAILURE = 'GET_SERVICE_ELIGIBILITY_DETAILS_FAILURE';

export const GET_STAFF_PLAN_ELIGIBILITY_REQUEST = 'GET_STAFF_PLAN_ELIGIBILITY_REQUEST';
export const GET_STAFF_PLAN_ELIGIBILITY_SUCCESS = 'GET_STAFF_PLAN_ELIGIBILITY_SUCCESS';
export const GET_STAFF_PLAN_ELIGIBILITY_FAILURE = 'GET_STAFF_PLAN_ELIGIBILITY_FAILURE';

export const STAFF_PLAN_RECON_ELIGIBILITY_REQUEST = 'STAFF_PLAN_RECON_ELIGIBILITY_REQUEST';
export const STAFF_PLAN_RECON_ELIGIBILITY_SUCCESS = 'STAFF_PLAN_RECON_ELIGIBILITY_SUCCESS';
export const STAFF_PLAN_RECON_ELIGIBILITY_FAILURE = 'STAFF_PLAN_RECON_ELIGIBILITY_FAILURE';
